import { backgroundOrange } from '@/theme/colors'
import styled from 'styled-components'

export const BoardHeader = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
`


export const DragOverlayCard = styled.div`
	transform: rotate(3deg);
	cursor: grabbing;
`

export const BoardContainer = styled.div`
	background: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 1.5rem 0 0 0;

	@media (max-width: 600px) {
		padding: 1rem 0 0 0;
	}
`


export const ScrollableColumnsWrapper = styled.div`
	overflow-x: auto;
	overflow-y: hidden;
	flex: 1;
	min-height: 0;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		height: 8px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: #d1d5db;
		border-radius: 4px;

		&:hover {
			background: #9ca3af;
		}
	}

	/* Firefox */
	scrollbar-width: thin;
	scrollbar-color: #d1d5db #f1f1f1;
`

export const ColumnsContainer = styled.div`
	display: flex;
	gap: 1rem;
	align-items: flex-start;
	height: 100%;
	padding: 0 0 1rem 0;

	/* Add spacing after the last column using pseudo-element */
	/* This prevents right padding from being clipped by overflow-x */
	&::after {
		content: '';
		display: block;
		min-width: 1rem;
	}
`

export const LoadingState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 400px;
	color: #6c757d;
`

export const LoadingSpinner = styled.div`
	width: 40px;
	height: 40px;
	border: 4px solid #e9ecef;
	border-top: 4px solid #007bff;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-bottom: 1rem;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 400px;
	text-align: center;
	color: #6c757d;
	padding: 2rem;
`

export const EmptyStateIcon = styled.div`
	font-size: 4rem;
	margin-bottom: 1rem;
	opacity: 0.5;
`

export const EmptyStateTitle = styled.h3`
	margin: 0 0 0.5rem 0;
	font-size: 1.5rem;
	font-weight: 600;
	color: #495057;
`

export const EmptyStateDescription = styled.p`
	margin: 0;
	font-size: 1rem;
	max-width: 400px;
	line-height: 1.5;
`

export const ErrorState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 400px;
	text-align: center;
	color: #dc3545;
	padding: 2rem;
`

export const ErrorIcon = styled.div`
	font-size: 4rem;
	margin-bottom: 1rem;
`

export const ErrorTitle = styled.h3`
	margin: 0 0 0.5rem 0;
	font-size: 1.5rem;
	font-weight: 600;
`

export const ErrorDescription = styled.p`
	margin: 0;
	font-size: 1rem;
	max-width: 400px;
	line-height: 1.5;
`

export const RetryButton = styled.button`
	margin-top: 1rem;
	padding: 0.75rem 1.5rem;
	background: #dc3545;
	color: white;
	border: none;
	border-radius: 6px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: #c82333;
	}
`
